<script setup lang="ts">
const props = defineProps<{
  product: unknown
}>()

const productMediaGallery = computed(() => {
  return (props.product?.media_gallery || []).map((item: any) => ({
    src: item?.url || item?.video_content?.video_url || '',
    alt: item?.label,
  }))
})

const mediaGalleryName = 'media-gallery'
</script>

<template>
  <UiMediaGallery
    :name="mediaGalleryName"
    :options="{
      behavior: 'smooth',
      fullscreen: true,
      media: productMediaGallery,
      navigation: productMediaGallery?.length !== 1,
      thumbs: true,
      thumbsDirection: 'horizontal',
      thumbsTrigger: 'mouseover',
      dots: false,
      XofY: false,
      fullscreenOptions: {
        dots: false,
        navigation: productMediaGallery?.length !== 1,
        thumbs: true,
        thumbsDirection: 'horizontal',
        thumbsTrigger: 'click',
        XofY: true,
      },
    }"
  >
    <slot />
  </UiMediaGallery>
</template>

<style>
@import url("~layers/app/components/Product/MediaGallery/index.css");
</style>
